(ns net.kestec.mhda-pilgrimage
  (:require
    ["@mui/material/CssBaseline" :default CssBaseline]
    ["@mui/material/Typography" :default Typography]
    ["@mui/material/styles" :refer [ThemeProvider]]
    ["@mui/x-date-pickers/AdapterDayjs" :refer [AdapterDayjs]]
    ["@mui/x-date-pickers/LocalizationProvider" :refer [LocalizationProvider]]
    [goog.dom :as gdom]
    [re-frame.core :as rf]
    [reagent.dom.client :as dom]
    [reitit.frontend.easy :as easy]
    [reagent.core :as r]

    [net.kestec.mhda-pilgrimage.theme :refer [mhda-theme]]
    [net.kestec.mhda-pilgrimage.route :as route]
    [net.kestec.mhda-pilgrimage.routes :as routes]
    ))


(def root
  [:> ThemeProvider {:theme mhda-theme}
   [(fn [] (route/content @(rf/subscribe [::route/route])))]
   ])

(defonce dom-root (dom/create-root (gdom/getElement "app")))


(defn ^:export ^:dev/after-load main []
  (when ^boolean goog.DEBUG
    (rf/clear-subscription-cache!))
  (easy/start! routes/router
               #(when % (rf/dispatch [::route/navigated %]))
               {:use-fragment false})
  (dom/render dom-root root))

